module.exports = __webpack_public_path__ + "img/01.ed6c1f2e.png";